var watchlistPositionDelete = {
	title: "Stelle löschen",
	caption: "Zu löschende Stelle",
	name: "Name",
	alertHeading: "Möchten Sie diese Position wirklich löschen?",
	alertBody: "Wenn ja, dann klicken Sie auf ok. Bitte beachten Sie, dass gelöschte Positionen nicht wiederhergestellt werden können.",
	confirmBtn: "Ok",
	cancelBtn: "Abbrechen"
};
var de = {
	watchlistPositionDelete: watchlistPositionDelete
};

export { de as default, watchlistPositionDelete };
